import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { LanguageProvider } from "./i18n/LanguageContext";
import { AuthProvider } from "./context/AuthContext";
import { BookingProvider } from "./context/BookingContext";
import { Toaster } from "./components/ui/sonner";

import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";

import Home from "./pages/Home";
import KnowledgeIndex from "./pages/KnowledgeIndex";
import PillarPage from "./pages/PillarPage";
import LifeConcerns from "./pages/LifeConcerns";
import Festivals from "./pages/Festivals";
import Astrology from "./pages/Astrology";
import Kundali from "./pages/Kundali";
import AstroAsk from "./pages/AstroAsk";
import Matching from "./pages/Matching";
import DreamReading from "./pages/DreamReading";
import PanchangPage from "./pages/PanchangPage";
import UnlockSuccess from "./pages/UnlockSuccess";
import Visit from "./pages/Visit";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Legal from "./pages/Legal";
import NotFound from "./pages/NotFound";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <AuthProvider>
          <BookingProvider>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/knowledge" element={<KnowledgeIndex />} />
                <Route path="/knowledge/:slug" element={<PillarPage />} />
                <Route path="/life-concerns" element={<LifeConcerns />} />
                <Route path="/festivals" element={<Festivals />} />
                <Route path="/astrology" element={<Astrology />} />
                <Route path="/astrology/kundali" element={<Kundali />} />
                <Route path="/astrology/ask" element={<AstroAsk />} />
                <Route path="/astrology/matching" element={<Matching />} />
                <Route path="/astrology/dream" element={<DreamReading />} />
                <Route path="/astrology/panchang" element={<PanchangPage />} />
                <Route path="/astrology/unlock-success" element={<UnlockSuccess />} />
                <Route path="/visit" element={<Visit />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/privacy" element={<Legal kind="privacy" />} />
                <Route path="/terms" element={<Legal kind="terms" />} />
                <Route path="/disclaimer" element={<Legal kind="disclaimer" />} />
                <Route path="/editorial" element={<Legal kind="editorial" />} />
                <Route path="*" element={<NotFound />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
            </Routes>
            <Toaster position="top-center" theme="light" richColors />
          </BookingProvider>
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
